import { GroupDot } from "@mixitone/components";
import { Account, ClubPlayer, type Player } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface Props {
  player: Player | ClubPlayer;
  hideName?: boolean;
  inline?: boolean;
  size?: number;
  className?: string;
  dotClassName?: string;
  whitespaceWrap?: boolean;
  showLevel?: boolean;
  onClick?: React.MouseEventHandler;
}

const PlayerDot: React.FC<Props> = ({
  player,
  inline,
  size,
  className,
  dotClassName,
  hideName,
  showLevel,
  onClick,
  whitespaceWrap,
}) => {
  const dotSize = size || 17;
  const name = player instanceof ClubPlayer ? player.name : player.clubPlayer.name;
  const level =
    player instanceof ClubPlayer
      ? player.graduation_level
      : player.clubPlayer.loaded
        ? player.clubPlayer.graduation_level
        : undefined;
  const showLevelInDot = Boolean(
    showLevel && Account.current?.hasFeature("group_levels") && player.group?.graduation_enabled && level,
  );

  const handleClick: React.MouseEventHandler = (event) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <div
      className={twMerge(
        clsx("player-dot flex cursor-pointer items-center gap-2", {
          "flex-col": !inline,
        }),
        className,
      )}
      onClick={handleClick}
    >
      <GroupDot
        group={player.group}
        size={dotSize}
        className={dotClassName}
        label={showLevelInDot ? String(level) : undefined}
      />
      <span
        data-testid="player-name"
        className={clsx({
          "whitespace-nowrap": !whitespaceWrap,
          invisible: hideName,
        })}
      >
        {name}
      </span>
    </div>
  );
};

export default ApplicationView(PlayerDot);
